import { render, staticRenderFns } from "./QuotaBeautifyDialog.vue?vue&type=template&id=572687bd&scoped=true&"
import script from "./QuotaBeautifyDialog.vue?vue&type=script&lang=js&"
export * from "./QuotaBeautifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuotaBeautifyDialog.vue?vue&type=style&index=0&id=572687bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572687bd",
  null
  
)

export default component.exports